import { useState } from "react";
import "../../styles/Components/mostvieweditems.css";

const MostViewedItem = ({ item, lang }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div onClick={() => window.open(item.product_url, "_blank")}>
      <div className="d-flex">
        <div
          className={` ${
            lang === "ar" ? "ml-20" : "mr-20"
          } image-container-most-view`}
        >
          {!imageLoaded && (
            <div className="">
              <div className="shimmer-effect"></div>
            </div>
          )}
          {/* Shimmer Effect */}
          <img
            src={item.image_url}
            alt=""
            width={137}
            height={97}
            onLoad={() => setImageLoaded(true)}
            className={imageLoaded ? "fade-in" : "d-none"}
          />{" "}
        </div>
        <div className={` ${lang === "ar" ? "ml-20" : "mr-20"}`}>
          {/* <h3 className="text-16 text-141414 mb-14 font-Montserrat-600">{}</h3> */}
          <p className="text-14 font-400 mb-12 text-3F3F3F">
            {" "}
            {lang === "ar"
              ? item.name_arabic
                  .replace(/^['"]+|['"]+$/g, "")
                  .replace(/(['"])\./g, ".")
              : item.name_english
                  .replace(/^['"]+|['"]+$/g, "")
                  .replace(/(['"])\./g, ".")}
          </p>
          <p className="font-500 text-14 font-500 mb-0">Views: {item.views}</p>
        </div>
        <div className="text-16 font-600 text-3C4242">
          {item.price_unit} {item.price_amount}
        </div>
      </div>
      <div className="separator my-12"></div>
    </div>
  );
};

export default MostViewedItem;
